import type { DriverDocumentType } from '../enums/DriverDocumentType'

export class DriverDocumentEntity {
  id?: number
  filePath?: string | null
  documentType?: DriverDocumentType
}
